export function hasValues(obj) {
  if (obj && typeof obj === "object") {
    const keys = Object.keys(obj);
    // Check for properties and ensure they are not empty arrays or objects
    if (keys.length > 0) {
      return keys.some(key => {
        const value = obj[key];
        return value !== null && (typeof value !== 'object' || Object.keys(value).length > 0);
      });
    }
  }
  return false;
}

export function getExtensionFromMimeType(mimeType) {
  const mimeToExtensionMap = {
    'application/pdf': 'pdf',
    'image/jpeg': 'jpg',          // Standard for photographic images
    'image/png': 'png',           // Supports transparency and lossless compression
    'image/gif': 'gif',           // Supports animation
    'image/bmp': 'bmp',           // Bitmap images
    'image/svg+xml': 'svg',       // Scalable Vector Graphics
    'image/tiff': 'tiff',         // High-quality images supported by photographers
    'image/webp': 'webp',         // Modern format for excellent compression
    'image/x-icon': 'ico',        // Icons for websites
    'image/heic': 'heic',         // High Efficiency Image Format used by Apple devices
    'image/heif': 'heif',         // High Efficiency Image File Format
    'image/psd': 'psd',           // Photoshop Document
    'image/vnd.adobe.photoshop': 'psd',  // Photoshop Document
    'image/x-cmu-raster': 'ras',  // Sun raster format
    'image/x-portable-bitmap': 'pbm',  // Portable Bitmap format
    'image/x-portable-graymap': 'pgm',  // Portable Graymap format
    'image/x-portable-pixmap': 'ppm',  // Portable Pixmap format
    'image/x-rgb': 'rgb',         // Raw RGB format
    'image/x-xbitmap': 'xbm',     // X Bitmap format
    'image/x-xpixmap': 'xpm',     // X Pixmap format
    'image/x-windowdump': 'xwd',  // X Window Dump
    'image/x-portable-anymap': 'pnm'  // Portable Anymap format      
  };

  return mimeToExtensionMap[mimeType] || null; // Return null if the MIME type is not recognized
}


export function generateUniqueCode(length) {
  if (length <= 0) {
    throw new Error("Length must be greater than 0");
  }

  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const randomValues = new Uint8Array(length);

  // Use crypto to generate secure random values
  window.crypto.getRandomValues(randomValues);

  // Map random values to the character set
  return Array.from(randomValues)
    .map((value) => chars[value % chars.length])
    .join('');
}



export function getMimeTypeCodeFromMimeType(mimeType) {
  const mimeToCodeMap = {
    'image/jpeg': 'MTYPJPG',
    'image/png': 'MTYPPNG',
    'application/pdf': 'MTYPPDF',
    // Add more MIME types and their associated extensions as needed
  };

  return mimeToCodeMap[mimeType] || null; // Return null if the MIME type is not recognized
}

export const getMimeType = (fileExtension) => {
  switch (fileExtension) {
    case 'pdf':
      return 'application/pdf';
    case 'csv':
      return 'text/csv';
    default:
      return 'application/octet-stream';
  }
};

export function getRandomColor() {
  return '#' + (Math.random().toString(16) + '000000').substring(2, 8).toUpperCase();
}


export function getRefById(refs, id) {
  return refs?.find(element => element.id === id);
}


export function getRefCodeById(refs, id) {
  const ref = refs?.find(element => element.id === id);
  return ref?.code;
}

export const getRefByCode = (refs, code, kindCode) => {
  return refs?.find(entry => entry.code === code && entry.kindCode === kindCode);
}

export const getRefIdByCode = (refs, code, kindCode) => {
  const item = refs?.find(entry => entry.code === code && entry.kindCode === kindCode);
  return item ? item.id : null;
}

export const getRefValueByCode = (refs, code, kindCode) => {
  const item = refs?.find(entry => entry.code === code && entry.kindCode === kindCode);
  return item?.value;
}
// Function to get distinct kind_id and kind_name
export const getDistinctKinds = (data) => {
  const result = data?.reduce((acc, item) => {
    // Check if this kindId is already in the accumulator
    if (!acc.some(a => a.value === item.kindId)) {
      acc.push({ label: item.kindName, value: item.kindId });
    }

    return acc;
  }, []);

  return result;
}


//helps to perform deep checks to avoid state re-renders and infinite loops
export const arraysAreEqual = (arr1, arr2) => JSON.stringify(arr1) === JSON.stringify(arr2);

export const isEmptyArray = (arr) => Array.isArray(arr) && arr.every(isEmptyArray);

export const isEmptyObject = (obj) => Object.keys(obj).length === 0 && obj.constructor === Object;

export const getArrFromStrWithDelim = (str, delim) => {
  if (!str) {
    return [];
  }
  return str?.split(delim);
}

// Define an array of distinct colors
export const colors = ['#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6',
  '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
  '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
  '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
  '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
  '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
  '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
  '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
  '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
  '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'];


export const yesNoItems = [
  { value: 'Y', name: 'Yes' },
  { value: 'N', name: 'No' }
];

export const truncateText = (text, maxLength = 52) => {
  if (!text) return '';
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
}; 
